import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedModule } from '../shared.module';
import { SnackBarTemplateComponent } from './components/snack-bar-template/snack-bar-template.component';
import { SnackBarComponent } from './components/snack-bar.component';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    SharedModule,
  ],
  exports: [SnackBarComponent, SnackBarTemplateComponent, MatSnackBarModule],
  declarations: [SnackBarComponent, SnackBarTemplateComponent],
  providers: [],
})
export class SnackBarModule {}
